module.exports = __webpack_public_path__ + "static/media/icon-emoji-happy.75b9098e.svg";